/**
 * Types of user activities that can be tracked
 */
export enum UserActivityType {
    APP_OPEN = 'APP_OPEN',
    QUIZ_RESULT_VIEW = 'QUIZ_RESULT_VIEW',
    VIDEO_VIEW = 'VIDEO_VIEW',
    CAMPUS_RESOURCE_VIEW = 'CAMPUS_RESOURCE_VIEW',
}
